import { useMemo } from 'react';

import { Link, useLocation } from 'react-router-dom';

import routes from '@/shared/constants/routesPath';
import { cn } from '@/shared/utils';

import Button from '@/components/ui/button';
import useScroll from '@/hooks/useScroll';

const Footer = () => {
  const location = useLocation();
  const isScrollingDown = useScroll();

  const swedishLeagueLink = useMemo(() => {
    const params = new URLSearchParams(location.search);
    params.set('panel', 'swedish-league');

    const search = params.toString();

    return {
      pathname: routes.HOME,
      search: search ? `?${search}` : undefined,
    };
  }, [location.search]);

  return (
    <footer
      className={cn(
        'fixed w-full left-0 right-0 bottom-0 z-10 border-t border-t-white/20 bg-white/5 py-4 backdrop-blur-lg shadow-lg transition-transform duration-300 md:py-5',
        isScrollingDown ? 'translate-y-0' : 'translate-y-full'
      )}
    >
      <div className="flex max-w-[1360px] flex-col-reverse items-center gap-4 px-4 md:container md:flex-row md:justify-between md:gap-0">
        <div className="flex flex-row-reverse items-center md:flex-row">
          <p className="text-base opacity-40">
            &copy; {new Date().getFullYear()} Lanetalk
          </p>
          <div className="h-6 border-l border-white/20 mx-4"></div>
          <Button variant="link" asChild>
            <Link to={swedishLeagueLink}>Swedish league</Link>
          </Button>
        </div>
        <div>
          <Link
            to={routes.TERMS}
            className="opacity-40 transition-opacity hover:opacity-100"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </Link>
          <span className="mx-2 opacity-40">/</span>
          <Link
            to={routes.PRIVACY}
            className="opacity-40 transition-opacity hover:opacity-100"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
